import { HomeClockIcon } from './HomeClockIcon';

/**
 * author: Colton Wiscombe
 * id F3391DCE-6EC9-4C63-869D-36ED374054FC
 * name home-clock
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-clock.svg
 * tags
 * - Home Automation 
 * - Date / Time 
 */
export const HouseTimeIcon = HomeClockIcon;
export default HouseTimeIcon